module.exports = __webpack_public_path__ + "static/media/t14.7e9ada98.jpg";